<div class="amount-wrapper">
	<div class="amount-content">
		<div class="amount-body">
			<h1 *ngIf="isVisible" style="font-weight: 700">{{entire}}<small>{{ decimal }}</small></h1>
      <h1 *ngIf="!isVisible" style="font-weight: 700">$ *.***<small>**</small></h1>
		</div>
	</div>
</div>
